import { render, staticRenderFns } from "./Separator.vue?vue&type=template&id=769da30c&scoped=true&"
var script = {}
import style0 from "./Separator.vue?vue&type=style&index=0&id=769da30c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "769da30c",
  null
  
)

export default component.exports